import _ from 'lodash';
import { CHAIN_ID } from '../chain';

export enum CHART_TYPE {
  PRICE = 'Price',
  DEPTH = 'Depth',
  DETAIL = 'Detail',
  ADD_LIQ = 'AddLq',
  FUNDING = 'Funding',
  INFO = 'Info',
  VOLUME = 'Volume',
  // only show orderbook chart in mobile for now
  ORDERBOOK = 'Orderbook',
}
export enum CHART_DURATION {
  H = 'H',
  D = 'D',
  W = 'W',
  M = 'M',
}
export enum TRADE_TYPE {
  MARKET = 'market',
  LIMIT = 'limit',
  SCALE_LIMIT = 'scale_limit',
  ADJUST_MARGIN = 'adjust_margin',
  CLOSE_POSITION = 'close_position',
  DEPOSIT_NATIVE = 'deposit_native',
}

export const IMR_ERROR = '0xde4607ee'; //'Insufficient margin to open position';
export const MMR_ERROR = '0x2f61ef0b'; // 'Insufficient margin for this trade';
export const OPEN_ORDER_QUERY_KEY = 'openOrder';

export enum MANAGE_SIDE {
  IN = 'IN',
  OUT = 'OUT',
}
export enum LEVERAGE_ADJUST_TYPE {
  BY_AMOUNT = 'by_amount',
  BY_LEVERAGE = 'by_leverage',
}

export const getImrStepRatio = (imr = DEFAULT_IMR, chainId?: number) => {
  let res = [1, 10, imr * 0.1, imr * 0.2];
  if (imr <= 100) {
    res = [1, 10, 20, 40];
  } else if (imr >= 1000) {
    res = [1, 10, 100, 200];
  }
  if (chainId === CHAIN_ID.BASE) {
    return res.filter((item) => item !== 1);
  }
  return res;
};
export const getScaleLimitStepRatio = (imr = DEFAULT_IMR, chainId?: number) => {
  let res = _.sortedUniq([1, 5, 10, 20, imr * 0.1, imr * 0.2]);
  if (imr <= 100) {
    res = [1, 5, 10, 20, 40];
  } else if (imr >= 1000) {
    res = [1, 5, 10, 20, 100, 200];
  }
  if (chainId === CHAIN_ID.BASE) {
    return res.filter((item) => item !== 1);
  }
  return res;
};
export const DEFAULT_IMR = 100;
export const DEFAULT_STEP_RATIO = 10;
export const DEFAULT_MAX_COUNT = 9;
export const DEFAULT_ORDER_COUNT = 5;
export const MIN_ORDER_COUNT = 2;
export const DEFAULT_ORDER_GAP = 4;
export const DEFAULT_LEVERAGE = 5;

export const INVALID_PRICE = 'Invalid price';
export enum TRADE_OVERLAY_TYPE {
  LEVERAGE = 'leverage',
  CLOSE_POSITION = 'close_position',
  ADJUST_MARGIN = 'adjust_margin',
  DEPOSIT_NATIVE = 'deposit_native',
  ADD_LIQ = 'add_liq',
  REMOVE_LIQ = 'remove_liq',
  SETTING = 'setting',
}

// Limit order SDK mark price slippage
export const LIMIT_ORDER_MARK_PRICE_SLIPPAGE = 1.0051;
